import styled, { css } from 'styled-components';
import { getCDNImageUrl } from '@/helpers/cdn';
import { device, hexToRGB, typography } from '@/styles/helpers';
import { MessageTypeEnum } from './helpers';

interface IScMessageContainerProps {
  withBorder?: boolean;
  type: MessageTypeEnum;
}

const warningIcon = getCDNImageUrl('/icon-img/warningIcon.svg');
const infoIcon = getCDNImageUrl('/icon-img/infoIconTooltip.svg');
const successIcon = getCDNImageUrl('/icon-img/successCircleIcon.svg');

export const ScMessageContainer = styled.div<IScMessageContainerProps>`
  display: flex;
  align-items: center;
  width: 100%;
  padding: ${({ withBorder }) => (withBorder ? '12px' : '8px 16px')};
  border-radius: 16px;
  ${({ withBorder, theme, type }) =>
    withBorder &&
    css`
      outline: 1px solid
        ${(() => {
          switch (type) {
            case MessageTypeEnum.Warning:
              return theme.pending;
            case MessageTypeEnum.Success:
              return theme.greenColor;
            default:
              return null;
          }
        })()};
      outline-offset: -1px;
    `}
  background: ${({ theme, type, withBorder }) => {
    if (withBorder) return 'none';
    const MAP_TYPE_TO_COLOR: Record<MessageTypeEnum, string> = {
      [MessageTypeEnum.Warning]: hexToRGB(theme.yellowColor, 0.2),
      [MessageTypeEnum.Info]: hexToRGB(theme.lightBlue, 0.2),
      [MessageTypeEnum.Success]: hexToRGB(theme.greenColor, 0.2),
    };
    return MAP_TYPE_TO_COLOR[type];
  }};

  .icon {
    display: flex;
    width: 24px;
    height: 24px;
    min-width: 24px;
    margin-right: 16px;

    &.warning-icon {
      background: ${() => `url(${warningIcon}) center no-repeat`};
    }

    &.info-icon {
      background: ${() => `url(${infoIcon}) center no-repeat`};
    }

    &.success-icon {
      background: ${() => `url(${successIcon}) center no-repeat`};
    }
  }

  & .message {
    ${typography['body2regular']}
    color: ${({ theme }) => theme.blackColor};
    white-space: pre-line;
    margin: 0;

    @media (${device.mobile}) {
      color: ${({ theme }) => theme.whiteColor};
    }
  }
`;
